/** Hands a file the console built to the browser's download (CSV export). */
export function saveFile(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.append(link);
  link.click();
  link.remove();
  // After the click the browser holds its own reference.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
